import { render } from "./FileUploadCard.vue?vue&type=template&id=c3f57716&scoped=true"
import script from "./FileUploadCard.vue?vue&type=script&lang=js"
export * from "./FileUploadCard.vue?vue&type=script&lang=js"

import "./FileUploadCard.vue?vue&type=style&index=0&id=c3f57716&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-c3f57716"]])

export default __exports__